import { Navigate } from "react-router-dom";
import RecepionNav from "../../pages/Dashboard/Reception/RecepionNav";
import ReceptionIndex from "../../pages/Dashboard/Reception/ReceptionIndex";
import NewPatient from "../../pages/Dashboard/Reception/NewPatient/NewPatient";
import PatientList from "../../pages/Dashboard/Reception/PatientList/PatientList";
import Appointments2 from "../../pages/Dashboard/Reception/Appointments2/Appointments2";
import CollectPrescriptionFees from "../../pages/Dashboard/Reception/CollectPrescriptionFees/CollectPrescriptionFees";
import CollectMedicineOrderFees from "../../pages/Dashboard/Reception/CollectMedicineOrderFees.js/CollectMedicineOrderFees";
import EchoCollectFees from "../../pages/Dashboard/Reception/echoCollectFees/EchoCollectFees";
import LaboratoryCollectFees from "../../pages/Dashboard/Reception/laboratoryCollectFees/LaboratoryCollectFees";
import UltrasoundReferral from "../../pages/Dashboard/Reception/ultrasoundCollectFees/UltrasoundReferral";
import XRayReferral from "../../pages/Dashboard/Reception/xrayCollectFees/XRayReferral";
import CollectDentalFees from "../../pages/Dashboard/Reception/CollectDentalFees/CollectDentalFees";
import CollectBeautyFees from "../../pages/Dashboard/Reception/CollectBeautyFees/CollectBeautyFees";
import CollectHtPatientFees from "../../pages/Dashboard/Reception/CollectHtPatientFees/CollectHtPatientFees";
import CollectDentalFeesList from "../../pages/Dashboard/Reception/CollectDentalFees/CollectDentalFeesList";
import CollectBeautyFeesList from "../../pages/Dashboard/Reception/CollectBeautyFees/CollectBeautyFeesList";
import CollectHtPatientFeesList from "../../pages/Dashboard/Reception/CollectHtPatientFees/CollectHtPatientFeesList";
import UltrasoundCollectFees from "../../pages/Dashboard/Reception/ultrasoundCollectFees/UltrasoundCollectFees";
import XrayCollectFees from "../../pages/Dashboard/Reception/xrayCollectFees/XrayCollectFees";
import EchoReferral from "../../pages/Dashboard/Reception/echoCollectFees/EchoReferral";
import PatientReferral from "../../pages/Dashboard/Reception/PatientReferral/PatientReferral";
import CollectEmergencyFees from "../../pages/Dashboard/Reception/CollectEmergencyFees/CollectEmergencyFees";
import CollectIPDFees from "../../pages/Dashboard/Reception/collectIPDFees/CollectIPDFees";
import CollectICUFees from "../../pages/Dashboard/Reception/collectICUFees/CollectICUFees";
import Expenses from "../../pages/Dashboard/Finance/Expenses/Expenses";
import ExpensesList from "../../pages/Dashboard/Finance/Expenses/ExpensesList";
import TicketingNav from "../../pages/Dashboard/Ticketing/TicketingNav";
import TicketList from "../../pages/Dashboard/Ticketing/TicketList";
import TicketCreate from "../../pages/Dashboard/Ticketing/TicketCreate";
import TicketView from "../../pages/Dashboard/Ticketing/TicketView";
import QueueList from "../../pages/Dashboard/Ticketing/QueueList/QueueList";
import EncounterTimeline from "../../pages/Dashboard/Ticketing/EncounterTimeline";
import ApprovalRequestList from "../../pages/Dashboard/Ticketing/ApprovalRequestList";
import CollectByTicket from "../../pages/Dashboard/Reception/CollectByTicket/CollectByTicket";

const receptionRoutes = {
  path: "/reception",
  element: <RecepionNav />,
  children: [
    { path: "/reception", element: <ReceptionIndex /> },
    { path: "/reception/new-patient", element: <NewPatient /> },
    { path: "/reception/patient-list", element: <PatientList /> },
    { path: "/reception/patient-referral", element: <PatientReferral /> },
    { path: "/reception/appointments", element: <Appointments2 /> },
    {
      path: "/reception/ticketing",
      element: <TicketingNav />,
      children: [
        {
          index: true,
          element: <Navigate to="/reception/ticketing/tickets" replace />,
        },
        {
          path: "tickets",
          element: <TicketList />,
        },
        {
          path: "tickets/new",
          element: <TicketCreate />,
        },
        {
          path: "tickets/:id",
          element: <TicketView />,
        },
        {
          path: "queue",
          element: <QueueList />,
        },
        {
          path: "encounters",
          element: <EncounterTimeline />,
        },
        {
          path: "encounters/patient/:patientId",
          element: <EncounterTimeline />,
        },
        {
          path: "approvals",
          element: <ApprovalRequestList />,
        },
      ],
    },
    {
      path: "/reception/payment-collection",
      element: <CollectByTicket />,
    },
    {
      path: "/reception/collect-prescription-fees",
      element: <CollectPrescriptionFees />,
    },
    {
      path: "/reception/collect-medicine-order-fees",
      element: <CollectMedicineOrderFees />,
    },
    {
      path: "/reception/collect-dental-fees",
      element: <CollectDentalFeesList />,
    },
    {
      path: "/reception/collect-dental-fees/add",
      element: <CollectDentalFees />,
    },
    {
      path: "/reception/collect-beauty-fees",
      element: <CollectBeautyFeesList />,
    },
    {
      path: "/reception/collect-beauty-fees/add",
      element: <CollectBeautyFees />,
    },
    {
      path: "/reception/collect-ht-patient-fees",
      element: <CollectHtPatientFeesList />,
    },
    {
      path: "/reception/collect-ht-patient-fees/add",
      element: <CollectHtPatientFees />,
    },
    {
      path: "/reception/collect-ultrasound-fees",
      element: <UltrasoundCollectFees />,
    },
    {
      path: "/reception/collect-ultrasound-fees/add",
      element: <UltrasoundReferral />,
    },
    {
      path: "/reception/collect-xray-fees",
      element: <XrayCollectFees />,
    },
    {
      path: "/reception/collect-xray-fees/add",
      element: <XRayReferral />,
    },
    {
      path: "/reception/collect-laboratory-fees",
      element: <LaboratoryCollectFees />,
    },
    {
      path: "/reception/collect-echo-fees",
      element: <EchoCollectFees />,
    },
    {
      path: "/reception/collect-echo-fees/add",
      element: <EchoReferral />,
    },
    {
      path: "/reception/collect-emergency-fees",
      element: <CollectEmergencyFees />,
    },
    {
      path: "/reception/collect-ipd-fees",
      element: <CollectIPDFees />,
    },
    {
      path: "/reception/collect-icu-fees",
      element: <CollectICUFees />,
    },

    { path: "/reception/add-expense", element: <Expenses /> },
    { path: "/reception/expenses", element: <ExpensesList /> },
  ],
};

export default receptionRoutes;
